export default "__VITE_ASSET__CN3dNBV3__"